<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
  },
  data() {
    return {
      site: 14,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>

<template>
  <ITCGridComponent
    columnas="2"
    :data="[
      {
        desc: '',
        icon: 'ptn-i-documento',
        target: null,
        title: 'Consulta de Expedientes',
        url: '?uid=CUMV-VIEW-ExpedientesComponent',
      },
      {
        desc: '',
        icon: 'question_answer',
        target: null,
        title: 'Consultas y solicitudes',
        url: '?uid=CUMV-VIEW-FormComponent',
      },
    ]"
  />

  <!--   <div class="container">
    <div class="row">
      <div class="col-md-12">
        <DocumentListComponent
          resultados="5"
          :show-fecha="false"
          titulo="Guía de Trámites"
          :filtros="{ site: this.site }"
        />
      </div>
    </div>
  </div> -->

  <CardGridComponent
    columnas="1"
    :data="[
      {
        target: '_blank',
        title: 'Licitaciones',
        url: 'https://licitaciones.sanjuan.gob.ar/',
      },
    ]"
  />

  <NewsComponent titulo="Noticias" />

  <section class="telefonos" id="desarrollo-telefonos">
    <div class="container">
      <h2 class="text-center text-secondary">Teléfonos útiles</h2>
      <p class="lead text-center">
        Listado de teléfonos útiles de la Provincia de San Juan.
      </p>
      <div
        class="row justify-content-between justify-content-md-around align-items-center"
      >
        <div class="col-md-4 text-center">
          <div class="card text-bg-secondary mb-2 mt-2">
            <div class="card-body">
              <p class="card-title alto-tit-org display-4">
                <span class="badge badge-secondary">102</span>
              </p>
              <h3 class="h5 my-0 font-weight-normal">
                <a
                  class="stretched-link text-white"
                  href="tel:102"
                  title="Niñas y niños en Riesgo"
                  >Niñas y niños en Riesgo</a
                >
              </h3>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <div class="card text-bg-secondary">
            <div class="card-body">
              <p class="card-title alto-tit-org display-4">
                <span class="badge badge-secondary">144</span>
              </p>
              <h3 class="h5 my-0 font-weight-normal">
                <a
                  class="stretched-link text-white"
                  href="tel:144"
                  title="Mujer"
                  >Mujer</a
                >
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <FrecuentAccessComponent
    titulo="Contactos Útiles"
    :data="[
      {
        title: 'Asesoría Letrada',
        links: [
          {
            target: null,
            title: '1° Piso Centro Cívico, Núcleo 1',
            url: null,
          },
          {
            target: '_blank',
            title: '(0264) 430 6007',
            url: 'tel:2644306007',
          },
          {
            target: '_blank',
            title: 'asesoria.mdhps@sanjuan.gov.ar',
            url: 'mailto:asesoria.mdhps@sanjuan.gov.ar',
          },
        ],
      },
    ]"
  />
  <!-- COMPONENTE AUTORIDADES -->
  <AutoriryComponent
    :showProtocolo="false"
    :showLinks="true"
    :data="[
      {
        title: 'Carlos Platero',
        subtitle: 'Ministro de Familia y Desarrollo Humano',
        imagen: require('@/assets/img/ministro-desarrollo.jpg'),
      },
    ]"
  />
</template>
